export const EVENT = {
    START_ANIMATION: 'START_ANIMATION'
}